import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { Breadcrumb } from '../shared/breadcrumb/breadcrumb.model';

@Component({
  selector: 'app-area-tecnologica',
  templateUrl: './area-tecnologica.component.html',
  styleUrls: ['./area-tecnologica.component.scss']
})
export class AreaTecnologicaComponent implements OnInit {

  constructor(private route: ActivatedRoute, private router: Router) { }

  areas: any[];
  cursos: any[];
  eixos: any[];
  area: any;
  eixo: any;
  error: any;
  paginaAtual: number;
  totalPaginas: number;
  totalResultados: number;

  isMobile$: Observable<boolean>;
  breadcrumbItems: Array<Breadcrumb> = [];

  ngOnInit(): void {
    this.route.data.subscribe((data) => {
      const {
        cursos: { itens, paginaAtual, totalPaginas, totalItens },
        eixo,
        area,
        areas,
        areaError,
        areasError
      } = data;

      this.error =
        areaError !== undefined || areasError !== undefined ? true : false;

      if (!this.error) {
        this.areas = areas;
        this.area = area;
        this.cursos = itens;
        this.paginaAtual = paginaAtual;
        this.totalPaginas = totalPaginas;
        this.totalResultados = totalItens;
        this.eixo = eixo;

        this.breadcrumbItems = [
          { label: 'Página Inicial', url: '/' },
          { label: 'Todos os Cursos', url: '/cursos' },
          { label: eixo.nome, url: `/cursos/eixo-tecnologico?id=${eixo.id}` },
          { label: area.nome }
        ];
      }
    });

  }

  /**
   *
   * @param numeroPagina índice de página.
   */
  onPaginaSelecionada(numeroPagina: number) {
    this.paginaAtual = numeroPagina;
    this.router.navigate(['/cursos/area'], {
      queryParamsHandling: 'merge',
      queryParams: {
        pagina: numeroPagina,
      },
    });
  }

}
